<!-- <p> -->

<!-- </p> -->

<div class="button-bar">
  <button (click)="modal.open('que-es')">{{'home.que_es' | translate}}</button>
  <button (click)="modal.open('que-preten')">{{'home.que_preten' | translate}}</button>
  <button (click)="modal.open('que-permet')">{{'home.que_permet' | translate}}</button>
  <button (click)="modal.open('com-funciona')">{{'home.com_funciona' | translate}}</button>
</div>

<div class="button-bar">
  <button class="main" (click)="goToSimulacio()">{{'home.simulacio' | translate}}</button>
</div>

<div class="recomanacio">
  <i class="fas fa-info-circle"></i>Recomanació per a la navegació: resolució mínima de pantalla de 1920 x 1080 píxels.
</div>

<vn-modal id="que-es" title="{{'home.que_es' | translate}}" [large]="'large'">
  <ng-container>
    El Mòdul de Suport a la Gestió del Risc és un sistema informàtic per:

    <ul>
      <li>Ajudar a reflexionar sobre casos reals o ficticis de risc en què es poden trobar infants i adolescents abans dels 18
    anys.</li>
      <li>Donar suport als/a les professionals en la presa de decisions sobre les intervencions adients davant de situacions
    reals que afecten un infant o adolescent en concret.</li>
      <li> Millorar la coordinació entre els professionals de la xarxa relacionada amb infància i adolescència i facilitar la
    transmissió d'informació.</li>
      <li>Agilitzar i actualitzar els canals de comunicació entre professionals.</li>
      <li>Incidir en la detecció de les situacions de risc o de maltractament en els primers estadis la qual cosa permeti
    intervenir de forma precoç.</li>
    </ul>
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>

<vn-modal id="que-preten" title="{{'home.que_preten' | translate}}" [large]="'large'">
  <ng-container>
    El Mòdul de Suport a la Gestió del Risc pretén:
    <br/><br/>
    Ser una eina per a la detecció, la prevenció i la comunicació de les situacions de risc o de <strong>maltractament
      intrafamiliar</strong> dels infants i adolescents.
    <ul>
      <li>S'entén per <strong>maltractament intrafamiliar</strong> el maltractament físic, psicològic, sexual o de qualsevol altre
        tipus que pateix l'infant, a mans d'algun membre del seu nucli familiar o quan els seus guardadors no l'han
        protegit del maltractament produït per persones alienes a la seva família.</li>
    </ul>
    Ser una eina de suport a la gestió del risc relacionada amb el maltractament a infants i adolescents.
    <ul>
      <li>El MSGR no està concebut per a substituir la decisió que ha d'adoptar el/la professional.</li>
    </ul>
    Orientar la persona usuària per a coordinar-se i/o notificar les situacions d'infants i adolescents en una situació
    de risc social i/o maltractament intrafamiliar.
    <ul>
      <li>El MSGR no substitueix els canals existents en el treball en xarxa dels serveis implicats en l'atenció a la
        infància ni tampoc dels protocols territorials establerts.</li>
    </ul>
    Servir per a l'anàlisi dels elements essencials d'un cas, en el moment de la seva detecció.
    <ul>
      <li>El MSGR no està concebut per a treballar amb dades obtingudes fruit del procés d'estudi i en profunditat d'un
        cas. En aquest sentit, els <strong>factors de protecció</strong> no es tenen en compte per fer una primera valoració del
        risc atès que han de ser valorats de forma més acurada pels professionals especialitzats, i formen part d'un
        estudi posterior al moment de la detecció.</li>
    </ul>
    Unificar els criteris sobre la valoració del risc i estructurar els continguts a compartir per la xarxa de
    professionals dels diferents àmbits.
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>

<vn-modal id="que-permet" title="{{'home.que_permet' | translate}}" [large]="'large'">
  <ng-container>
    Des del MSGR podeu:

    <ul>
      <li><strong>Fer una SIMULACIÓ</strong> per apreciar el risc concurrent en el cas hipotètic o real d'un infant o adolescent.
        <u>Aquesta acció és d'accés universal.</u>
      </li>
      <li>Es permet registrar observacions en relació amb un infant o adolescent en situació de risc.</li>
      <li>Segons la vostra professió o àmbit d'actuació, el programa mostrarà d'entrada només aquelles observacions que
        se'n deriven. Els ÀMBITS són: <strong>Educació, Cossos policials, Serveis socials, Salut.</strong></li>
      <li>Podeu també facilitar informació més detallada o complementària activant l'opció <strong>Tots els àmbits.</strong></li>
      <li>Permet informar de situacions actuals. Les dades que pertanyen al passat de l'infant o la família les podeu
        informar o bé a l'apartat de dades de context o bé als camps oberts d'observacions.</li>
      <li>Proposar noves observacions per a la millora contínua del sistema.</li>
    </ul>
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>

<vn-modal id="com-funciona" title="{{'home.com_funciona' | translate}}" [large]="'large'">
  <ng-container>
    En cas de fer una SIMULACIÓ, un cop introduïdes les dades, el programa emetrà una valoració sobre:

    <ul>
      <li>La <strong>gravetat de la situació</strong> en què es troba l'infant o adolescent, mitjançant l'activació d'un semàfor.
      </li>
      <li>La <strong>tipologia del maltractament.</strong></li>
      <li>El <strong>risc de repetir-se</strong> la situació de maltractament.</li>
      <li><strong>L'acció que us recomanaria</strong> fer si el cas fos real en funció del resultat del semàfor.</li>
    </ul>
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>